import { Box, Typography } from "@bca/ui-library";
import React from "react";
import { Vehicle } from "../Interfaces/vehicle.type";

interface InvoiceDetailsProps {
  vehicleData: Vehicle;
}

const InvoiceDetails: React.FunctionComponent<InvoiceDetailsProps> = ({
  vehicleData,
}) => {
  return (
    <Box
      display="flex"
      flexDirection="column"
      marginY={{
        mobile: "32px",
        desktop: "16px",
      }}
    >
      <Typography variant="body-small" color="footer-blue">
        Sale details and any applicable services and charges.
      </Typography>
      <Typography variant="body-small" marginY="4px">
        Vehicle Details
      </Typography>
      <Typography
        variant="body-small"
        marginY="4px"
        fontWeight="bold"
        color="footer-blue"
      >
        {vehicleData.primaryVehicleDescription}
      </Typography>
      <Typography
        variant="body-small"
        marginTop="0px"
        color="secondary-darkest-grey"
      >
        {vehicleData.secondaryDescription}
      </Typography>
    </Box>
  );
};

export default InvoiceDetails;
